module.exports = __webpack_public_path__ + "img/m2g_event.53cc09f4.png";